<script setup lang="ts">
import { useToast } from '@/composables/useToast'

const { toasts } = useToast()
</script>

<template>
  <div class="toast-host" aria-live="polite">
    <div v-for="toast in toasts" :key="toast.id" class="toast" :class="`toast-${toast.kind}`">
      {{ toast.message }}
    </div>
  </div>
</template>

<style scoped>
.toast-host {
  position: fixed;
  left: 50%;
  top: calc(env(safe-area-inset-top, 0px) + 0.5rem);
  z-index: 30;
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
  width: min(92vw, 30rem);
  transform: translateX(-50%);
  pointer-events: none;
}

.toast {
  padding: 0.6rem 0.9rem;
  border-radius: 12px;
  background: var(--tg-text-color);
  color: var(--tg-bg-color);
  font-size: 0.9rem;
  box-shadow: 0 4px 16px rgb(0 0 0 / 20%);
}

.toast-error {
  background: var(--tg-destructive-text-color);
  color: #fff;
}
</style>
